import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { LegalPage, LegalPageProps } from '../components/legal/LegalPage'
import { renderLegalDoc } from '../functions/legalContent'

type Props = Omit<LegalPageProps, 'docKey'>

/**
 * Termos de Uso v4.0 (handoff "Páginas Legais"): conteúdo em
 * content/legal/, renderizado build-time. PT é o idioma autoritativo em
 * /termos; qualquer outro locale recebe a tradução de trabalho EN (URL
 * canônica /en/terms-of-use via rewrite no next.config.js).
 */
export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
  const lang = locale === 'pt' ? 'pt' : 'en'
  const { html, toc } = renderLegalDoc('terms', lang)

  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'pt', ['common'])),
      lang,
      html,
      toc,
    },
  }
}

export default function Termos(props: Props) {
  return <LegalPage docKey="terms" {...props} />
}
